var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifyWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "41px",
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8B66\u544A_40dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "12.7066116%",
    x2: "0%",
    y2: "87.2933884%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4E40",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19F00",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 208,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0214\\u66F4\\u65B0-\\u901A\\u77E5\\u6837\\u5F0F",
    transform: "translate(-1076.000000, -121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD",
    transform: "translate(1058.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8B66\\u544A_40dp",
    transform: "translate(18.000000, 21.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(1.666667, 3.333333)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333333,0 L36.6666667,31.6666667 L0,31.6666667 L18.3333333,0 Z M18.3333333,6.65 L5.78333333,28.3333333 L30.8833333,28.3333333 L18.3333333,6.65 Z M19.8333333,22.3333333 L19.8333333,25.3333333 L16.8333333,25.3333333 L16.8333333,22.3333333 L19.8333333,22.3333333 Z M19.8333333,13.3333333 L19.8333333,20.8333333 L16.8333333,20.8333333 L16.8333333,13.3333333 L19.8333333,13.3333333 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyWarning);
export default __webpack_public_path__ + "static/media/notify_warning.545a9df2e609e50ebea7233dbd5dc3b2.svg";
export { ForwardRef as ReactComponent };